import styled from "styled-components";
import { useAppDispatch } from "../../app/hooks";
import { DeliveryGroup } from "../../types/schedule/delivery-group";
import { Schedule } from "../../types/schedule/schedule";
import { timeFormat } from "../../utils/date/date-format";
import Button from "../button/Button";
import { ActionGroupMap } from "../dialog/DeliveryGroupDialogContent";
import { DeliveryGroupInspectorItem } from "./DeliveryGroupInspectorItem";

interface Props {
  actionGroupMap: ActionGroupMap;
  schedule: Schedule;
  deliveryGroup: DeliveryGroup;
}

export const DeliveryGroupInspector: React.FC<Props> = ({
  actionGroupMap,
  schedule,
  deliveryGroup,
}) => {

  return (
    <InspectorContainer className={`${deliveryGroup.type}`}>
      <InspectorTitle>
        <InspectorTimeContainer>
          {/* <DeliveryGroupKeyLabel>
            {getDeliveryGroupKeyFormat(deliveryGroup.key)}
          </DeliveryGroupKeyLabel> */}
          <DeliveryGroupTimeLabel>
            {deliveryGroup.displayType} 예정{" "}
            {timeFormat(deliveryGroup.endTimeLimited)}
            {deliveryGroup.reportedAt && (
              <span> - 완료{" "}{timeFormat(deliveryGroup.reportedAt)}</span>
            )}
          </DeliveryGroupTimeLabel>
          {deliveryGroup.isDelay && (
            <DeliveryGroupDelayLabel>배송 완료 지연</DeliveryGroupDelayLabel>
          )}
        </InspectorTimeContainer>

        <InspectorTitleSecondLayer>
          {deliveryGroup.formattedAddress}
        </InspectorTitleSecondLayer>

        <InspectorTitleThirdLayer>
          {`주소 : ${deliveryGroup.location.road}`}
        </InspectorTitleThirdLayer>
      </InspectorTitle>

      <InspectorBody>
        <InspectorBodyTitle>
          <InspectorBodyTitleLabel>물품정보</InspectorBodyTitleLabel>
        </InspectorBodyTitle>
        {Object.keys(actionGroupMap).map((key) => {
          const actionGroup = actionGroupMap[key];
          if (!actionGroup) {
            return null;
          }
          return (
            <DeliveryGroupInspectorItem
              actionGroup={actionGroup}
              deliveryGroup={deliveryGroup}
              schedule={schedule}
            />
          );
        })}
      </InspectorBody>

    </InspectorContainer>
  );
};

const InspectorContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 20px 0 0 0;
  box-sizing: border-box;
  //   border-bottom-right-radius: 8px;
  background: #ffffff;

  //   &.PICK_UP {
  //     border-bottom-left-radius: 8px;
  //   }
`;

const InspectorTitle = styled.div`
  padding: 0px 24px 20px 24px;
  box-sizing: border-box;
`;

const InspectorTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  align-items: center;
`;

const DeliveryGroupDelayLabel = styled.p`
  font-weight: 600;
  font-size: 12px;
  color: #f94d57;
  margin-left: 4px;
`

const DeliveryGroupKeyLabel = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  color: #979da8;
  text-decoration: underline;
`;

const DeliveryGroupTimeLabel = styled.p`
  margin: 0;
  // margin-left: 8px;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  color: #121a2b;
`;

const InspectorTitleSecondLayer = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 21px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 16px;
`;

const InspectorTitleThirdLayer = styled.p`
  margin: 0;
  margin-bottom: 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #4d535c;
`;

const InspectorBody = styled.div`
  height: 548px;
  overflow-y: scroll;
  border-top: 1px solid #ebeef3;
  //border-bottom: 1px solid #ebeef3;
  //margin-bottom: 12px;
`;

const InspectorBodyTitle = styled.div`
  position: relative;
  padding: 20px 0px;
  // width: 388px;
  // margin: 0 auto;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef3;
`;

const InspectorBodyTitleLabel = styled.div`
  margin-left: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
`;

const InspectorBodyErrorLabel = styled.span`
  position: absolute;
  bottom: 5px;
  right: 0px;
  font-weight: 500;
  font-size: 11px;
  line-height: 126.02%;
  color: #f94d57;
`;

const InspectorFooter = styled.div`
  text-align: center;
`;

const InspectorFooterButton = styled(Button)`
  width: 388px;
  height: 51px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;
